import React from 'react';
import { Link } from 'react-router-dom';

// Material UI
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  section: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column", 
    justifyContent: "center",
    alignItems: "center",
  },
}))

const PageNotFound = () => {
  const classes = useStyles();

  return (
    <section id="page-not-found" className={classes.section}>
      <Typography variant="h5" className={classes.text} gutterBottom>
        {"Halaman tidak ditemukan :("}
      </Typography>
      <Typography gutterBottom>
        <Link to="/" className={classes.link}>
          {"Kembali ke Halaman Utama"}
        </Link>
      </Typography>
    </section>
  )
}

export default PageNotFound
